import axios from "../../axiosInstance";
import { getUserId } from "../../components/Utils/Common";

const Item_base_api = "/im/ob/import"
class ItemService{

    getHsCode(details){
        return axios.post(Item_base_api+'/getHsCode',details);
    }
    getItemNameSearch(itemName,flag){
        return axios.get(Item_base_api+'/getItemNameSearch?itemName='+itemName+'&flag='+flag);
    }
    getItemNotification(details){
        return axios.post(Item_base_api+'/getItemNotification',details);
    }
    getEndUseCode(details){
        return axios.post(Item_base_api+'/getEndUseCode',details);
    }
    getCustomNotification(details){
        return axios.post(Item_base_api+'/getCustomNotification',details);
    }
    insertItemNotification(details){
        return axios.post(Item_base_api+'/insertItemNotification',details);
    }
    getDutyType(){
        return axios.get(Item_base_api+'/getDutyType');
    }
    getAddlDutyType(){
        return axios.get(Item_base_api+'/getAddlDutyType');
    }
    insertIgst(details){
        return axios.post(Item_base_api+'/insertIgst',details);
    }
    insertIgstCess(details){
        return axios.post(Item_base_api+'/insertIgstCess',details);
    }
    getSchemeCode(details){
        return axios.post(Item_base_api+'/getSchemeCode',details);
    }
    getItemSchemeCode(itemId){
        return axios.get(Item_base_api+'/imp_getItemSchemeCode?itemId='+itemId);
    }
    import_item_insertItemSchemeCode(details){
        return axios.post(Item_base_api+'/import_item_insertItemSchemeCode',details);
    }
    import_item_updateItemSchemeCode(details){
        return axios.put(Item_base_api+'/import_item_updateItemSchemeCode',details);
    }
    import_item_deleteItemSchemeCode(NotificationId){
        return axios.delete(Item_base_api+'/import_item_deleteItemSchemeCode?NotificationId='+NotificationId);
    }
    getItemNotificationAntiDumping(details){
        return axios.post(Item_base_api+'/getItemNotificationAntiDumping',details);
    }
    insertItemNotificationAntiDumping(details){
        return axios.post(Item_base_api+'/insertItemNotificationAntiDumping',details);
    }
    updateItemNotificationAntiDumping(details){
        return axios.put(Item_base_api+'/updateItemNotificationAntiDumping',details);
    }
    deleteItemNotificationAntiDumping(NotificationId){
        return axios.delete(Item_base_api+'/deleteItemNotificationAntiDumping?NotificationId='+NotificationId);
    }
    getSwInfoType(){
        return axios.get(Item_base_api+'/getSwInfoType');
    }
    getItemSwInfo(details){
        return axios.post(Item_base_api+'/getItemSwInfo',details);
    }
    getSwInfoQualifier(details){
        return axios.post(Item_base_api+'/getSwInfoQualifier',details);
    }
    getSwInfoCode(details){
        return axios.post(Item_base_api+'/getSwInfoCode',details);
    }
    insertItemSwInfo(details){
        return axios.post(Item_base_api+'/import_item_insertItemSwInfo',details);
    }
    updateItemSwInfo(details){
        return axios.put(Item_base_api+'/import_item_updateItemSwInfo',details);
    }
    deleteItemSwInfo(NotificationId){
        return axios.delete(Item_base_api+'/import_item_deleteItemSwInfo?NotificationId='+NotificationId);
    }
    getLicenceDetails(details){
        return axios.post(Item_base_api+'/import_item_getLicenceDetails',details);
    }
    insertItemLicenceDetails(details){
        return axios.post(Item_base_api+'/import_item_insertItemLicenceDetails',details);
    }
    updateItemLicenceDetails(details){
        return axios.put(Item_base_api+'/import_item_updateItemLicenceDetails',details);
    }
    deleteItemLicenceDetails(NotificationId){
        return axios.delete(Item_base_api+'/import_item_deleteItemLicenceDetails?NotificationId='+NotificationId);
    }
    getSwConstitunet(details){
        return axios.post(Item_base_api+'/getSwConstitunet',details);
    }
    insertItemSwConstituent(details){
        return axios.post(Item_base_api+'/import_item_insertItemSwConstituent',details);
    }
    updateItemSwConstituent(details){
        return axios.put(Item_base_api+'/import_item_updateItemSwConstituent',details);
    }
    deleteItemSwConstituent(NotificationId){
        return axios.delete(Item_base_api+'/import_item_deleteItemSwConstituent?NotificationId='+NotificationId);
    }
    getItemRSP(details){
        return axios.post(Item_base_api+'/getItemRSP',details);
    }
    insertItemRSP(details){
        return axios.post(Item_base_api+'/insertItemRSP',details);
    }
    updateItemRSP(details){
        return axios.put(Item_base_api+'/updateItemRSP',details);
    }
    deleteItemRSP(NotificationId){
        return axios.delete(Item_base_api+'/deleteItemRSP?NotificationId='+NotificationId);
    }
    getItemReimport(details){
        return axios.post(Item_base_api+'/getItemReimport',details);
    }
    insertItemReimport(details){
        return axios.post(Item_base_api+'/insertItemReimport',details);
    }
    updateItemReimport(details){
        return axios.put(Item_base_api+'/updateItemReimport',details);
    }
    deleteItemReimport(NotificationId){
        return axios.delete(Item_base_api+'/deleteItemReimport?NotificationId='+NotificationId);
    }
    insertItemNotificationMultible(details){
        return axios.post(Item_base_api+'/insertItemNotificationMultible',details);
    }
    updateItemNotification(details){
        return axios.put(Item_base_api+'/updateItemNotification',details);
    }
    deleteItemNotification(NotificationId){
        return axios.delete(Item_base_api+'/deleteItemNotification?NotificationId='+NotificationId);
    }
    getSwProduction(details){
        return axios.post(Item_base_api+'/getSwProduction',details);
    }
    import_item_insertItemSwProduction(details){
        return axios.post(Item_base_api+'/import_item_insertItemSwProduction',details);
    }
    import_item_updateItemSwProduction(details){
        return axios.put(Item_base_api+'/import_item_updateItemSwProduction',details);
    }
    import_item_deleteItemSwProduction(NotificationId){
        return axios.delete(Item_base_api+'/import_item_deleteItemSwProduction?NotificationId='+NotificationId);
    }
    import_item_getManufacture(details){
        return axios.post(Item_base_api+'/import_item_getManufacture',details);
    }
    import_item_insertManufacture(details){
        return axios.post(Item_base_api+'/import_item_insertManufacture',details);
    }
    import_item_updateManufacture(details){
        return axios.put(Item_base_api+'/import_item_updateManufacture',details);
    }
    import_item_deleteManufacture(manufactureId){
        return axios.delete(Item_base_api+'/import_item_deleteManufacture?manufactureId='+manufactureId);
    }
    getCustomNotificationType(){
        return axios.get(Item_base_api+'/getCustomNotificationType');
    }
    getSwControl(details){
        return axios.post(Item_base_api+'/getSwControl',details);
    }
    insertItemSwControl(details){
        return axios.post(Item_base_api+'/import_item_insertItemSwControl',details);
    }
    updateItemSwControl(details){
        return axios.put(Item_base_api+'/import_item_updateItemSwControl',details);
    }
    deleteItemSwControl(NotificationId){
        return axios.delete(Item_base_api+'/import_item_deleteItemSwControl?NotificationId='+NotificationId);
    }
    getSwControlCode(){
        return axios.get(Item_base_api+'/getSwControlCode');
    }
    getSwControlResult(details){
        return axios.post(Item_base_api+'/getSwControlResult',details);
    }
    getSwStatementType(){
        return axios.get(Item_base_api+'/getSwStatementType');
    }
    getSwStatementCode(details){
        return axios.post(Item_base_api+'/getSwStatementCode',details);
    }
    getSwStatement(details){
        return axios.post(Item_base_api+'/getSwStatement',details);
    }
    insertItemSwStatement(details){
        return axios.post(Item_base_api+'/import_item_insertItemSwStatement',details);
    }
    updateItemSwStatement(details){
        return axios.put(Item_base_api+'/import_item_updateItemSwStatement',details);
    }
    deleteItemSwStatement(NotificationId){
        return axios.delete(Item_base_api+'/import_item_deleteItemSwStatement?NotificationId='+NotificationId);
    }
    getItemPolicyPara(details){
        return axios.post(Item_base_api+'/getItemPolicyPara',details);
    }
    insertItemPolicyPara(details){
        return axios.post(Item_base_api+'/insertItemPolicyPara',details);
    }
    updateItemPolicyPara(details){
        return axios.put(Item_base_api+'/updateItemPolicyPara',details);
    }
    deleteItemPolicyPara(NotificationId){
        return axios.delete(Item_base_api+'/deleteItemPolicyPara?NotificationId='+NotificationId);
    }
    getSwSupDocFileType(){
        return axios.get(Item_base_api+'/getSwSupDocFileType');
    }
    getSwSupportingDoc(details){
        return axios.post(Item_base_api+'/getSwSupportingDoc',details);
    }
    getSwSupDocType(details){
        return axios.post(Item_base_api+'/getSwSupDocType',details);
    }
    insertItemSwSupportingDoc(details){
        return axios.post(Item_base_api+'/import_item_insertItemSwSupportingDoc',details);
    }
    updateItemSwSupportingDoc(details){
        return axios.put(Item_base_api+'/import_item_updateItemSwSupportingDoc',details);
    }
    deleteItemSwSupDoc(NotificationId){
        return axios.delete(Item_base_api+'/import_item_deleteItemSwSupDoc?NotificationId='+NotificationId);
    }
    getInvoiceSummary(details){
        return axios.post(Item_base_api+'/getInvoiceSummary',details);
    }
    getItemSummary(details){
        return axios.post(Item_base_api+'/getItemSummary',details);
    }
    getCommercialItem(details){
        return axios.post(Item_base_api+'/getCommercialItem',details);
    }
    getCommercialItemAssign(details){
        return axios.post(Item_base_api+'/getCommercialItemAssign',details);
    }
    insertCommercialItemPreAlertNo(details){
        return axios.post(Item_base_api+'/insertCommercialItemPreAlertNo',details);
    }
    insertCommercialItem(details){
        return axios.post(Item_base_api+'/insertCommercialItem',details);
    }
    updateCommercialItem(details){
        return axios.put(Item_base_api+'/updateCommercialItem',details);
    }
    deleteCommercialItem(ItemIdString){
        return axios.delete(Item_base_api+'/deleteCommercialItem?ItemIdString='+ItemIdString);
    }
    checkBeFlatfileChecklistErrors(ConsignmentId){
        return axios.get(Item_base_api+'/checkBeFlatfileChecklistErrors?ConsignmentId='+ConsignmentId);
    }
    getICEGATEuser(details){
        return axios.post(Item_base_api+'/getICEGATEuser',details)
    }
    getbetypeJob(details){
        return axios.post(Item_base_api+'/getbetypeJob',details)
    }
    uploadItem(InvoiceId,file){
        let formData = new FormData();
        formData.append("file", file);
        return axios.post(Item_base_api+'/uploadItem?InvoiceId='+InvoiceId+'&createdby='+getUserId(),formData)
    }
    getItemErrorList(details){
        return axios.post(Item_base_api+'/getItemErrorList',details)
    }
    insertDuplicateItemImport(details){
        return axios.post(Item_base_api+'/insertDuplicateItemImport',details)
    }
    updateItemActiveStatus(details){
        return axios.put(Item_base_api+'/updateItemActiveStatus',details)
    }

}

export default new ItemService();